import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as DashboardIcon } from '../images/ic_dashboard.svg'
import { ReactComponent as TreeIcon } from '../images/ic-tree.svg'
import { ReactComponent as HistoryIcon } from '../images/ic-history.svg'
import { ReactComponent as SponsorTreeIcon } from '../images/ic_sponsortree.svg'
import { ReactComponent as NoticeIcon } from '../images/ic_notice.svg'
import { ReactComponent as CommissionIcon } from '../images/ic_detail.svg'

const Nav = () => {
    const location = useLocation()

    const NavDashboard = () => {
        if (location.pathname === '/dashboard') {
            return (
                <div className="active-link">
                    <DashboardIcon className="nav-icon-selected" />
                    Dashboard
                </div>
            )
        } else {
            return (
                <Link to="/dashboard">
                    <div className="non-link">
                        <DashboardIcon className="nav-icon" />
                        Dashboard
                    </div>
                </Link>
            )
        }
    }

    const NavSponsor = () => {
        if (location.pathname === '/sponsor') {
            return (
                <div className="active-link">
                    <SponsorTreeIcon className="nav-icon-selected" />
                    Sponsor
                </div>
            )
        } else {
            return (
                <Link to="/sponsor">
                    <div className="non-link">
                        <SponsorTreeIcon className="nav-icon" />
                        Sponsor
                    </div>
                </Link>
            )
        }
    }

    const NavReferral = () => {
        if (location.pathname === '/referral') {
            return (
                <div className="active-link">
                    <TreeIcon className="nav-icon-selected" />
                    Referral
                </div>
            )
        } else {
            return (
                <Link to="/referral">
                    <div className="non-link">
                        <TreeIcon className="nav-icon" />
                        Referral
                    </div>
                </Link>
            )
        }
    }

    const NavNotice = () => {
        if (location.pathname === '/notice') {
            return (
                <div className="active-link">
                    <NoticeIcon className="nav-icon-selected" />
                    Notice
                </div>
            )
        } else {
            return (
                <Link to="/notice">
                    <div className="non-link">
                        <NoticeIcon className="nav-icon" />
                        Notice
                    </div>
                </Link>
            )
        }
    }

    const NavCommission = () => {
        if (location.pathname === '/commission') {
            return (
                <div className="active-link">
                    <CommissionIcon className="nav-icon-selected" />
                    Commission
                </div>
            )
        } else {
            return (
                <Link to="/commission">
                    <div className="non-link">
                        <CommissionIcon className="nav-icon" />
                        Commission
                    </div>
                </Link>
            )
        }
    }

    const NavHistory = () => {
        if (location.pathname === '/history') {
            return (
                <div className="active-link">
                    <HistoryIcon className="nav-icon-selected" />
                    History
                </div>
            )
        } else {
            return (
                <Link to="/history">
                    <div className="non-link">
                        <HistoryIcon className="nav-icon" />
                        History
                    </div>
                </Link>
            )
        }
    }

    return (
        <div id="nav">
            <NavDashboard />
            {/* <NavReferral /> */}
            {/* <NavSponsor/> */}
            <NavNotice />
            <NavHistory />
            {/* <NavCommission /> */}
        </div>
    )
}

export default Nav
